import { useNavigate, useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";
import Home from "../Home";
import { getUser, removeUser } from "../utils/auth";
import { clearPenStorage } from "../utils/penStorage";

export default function HomePage() {
  const navigate            = useNavigate();
  const [searchParams]      = useSearchParams();
  const [user, setUser]     = useState(getUser);

  useEffect(() => {
    // Old share links pointed at /?pen=<token> before that route had any
    // pen-loading logic; forward them to the real shared-pen view so links
    // already shared/bookmarked with the old format keep working.
    const token = searchParams.get('pen');
    if (token) navigate(`/shared?pen=${token}`, { replace: true });
  }, [searchParams, navigate]);

  const handleLogout = () => {
    removeUser();
    setUser(null);
    navigate('/');
  };

  const handleNewPen = () => {
    clearPenStorage();
    navigate('/editor');
  };

  const handleSettings = () => {
    navigate('/editor?settings=true');
  };

  return (
    <Home
      user={user}
      onGetStarted={() => navigate('/editor')}
      onLogin={() => navigate('/login')}
      onNewPen={handleNewPen}
      onLogout={handleLogout}
      onExplore={() => navigate('/explore')}
      onBlog={() => navigate('/blog')}
      onSettings={handleSettings}
      onViewPens={() => navigate('/editor?pens=true')}
    />
  );
}